import {RadioConnected} from 'webmapsjs/dist/reactComponents/Radio';
import {DateRange} from 'webmapsjs/dist/reactComponents/DateRange';
import * as actions from '../actions';
import {iState} from '../npmrdsStore';
import {connect} from "react-redux";
import React = require("react");

export const DateRangeConnected = connect(
    (state: iState) => {
        return {
            maxRange: 10,
            start: state.startEndDate.start,
            end: state.startEndDate.end,
            initialEnd: new Date((document.getElementById('max-date') as HTMLInputElement).value),
            npmrds: true
        }
    },
    (dispatch) => {
        return {
            callback: (s: Date, e: Date, version: number) => {
                console.log(version);
                dispatch({type: actions.ACTION_START_END_DATE, start: s, end: e, version: version});
            }
        }
    }
)(DateRange);


const mapStateToProps = (state: iState) => {
    let outArr: string[] = [];

    for (let f of state.roads) {
        if (f.number == null) {
            continue;
        }

        if (state.startEndDate.version == 1) {
            outArr.push(`${f.number} ${f.direction}`)
        } else if (state.startEndDate.version == 2) {

            let dir = f.direction.trim();

            switch (dir) {
                case 'S':
                    dir = 'Southbound';
                    break;
                case 'N':
                    dir = 'Northbound';
                    break;
                case 'E':
                    dir = 'Eastbound';
                    break;
                case 'W':
                    dir = 'Westbound';
                    break;
                default:
                    if (['northbound', 'southbound', 'eastbound', 'westbound'].indexOf(dir.toLowerCase()) < 0) {
                        console.log("Strange Direction");
                        console.log(f.number, f.direction);
                    }
                    // throw 'invalid direction';
                    break;
            }

            let num = f.number.trim().replace(/\s[N|S|E|W]$/, '');

            outArr.push(`${num} ${dir}`)
        } else {
            throw 'Invalid version identifier'
        }
    }


    return {
        title: "Roads and Directions",
        items: outArr,
        selectedIndex: state.roadIndex,
        inline: false,
        classes: []
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        callback: (val: string) => {
            dispatch({type: actions.ACTION_SET_ROAD_INDEX, roadIndex: parseInt(val)});
        }
    }
};

export const RadioHwy = connect(
    mapStateToProps,
    mapDispatchToProps
)(RadioConnected);

class _VersionLabel extends React.Component<{
    version: number,
    startDate: Date,
    endDate: Date,
    npmrdsYear: number,
    npmrdsYearChange: (y: number) => any

}, null> {

    render() {

        let content = <div/>;

        return <div>
            <label>
                NPMRDS Version: {this.props.version}
                {this.props.version > 1 ? ` - ${this.props.endDate.getFullYear()}` : ''}
            </label>
        </div>
    }
}

export const VersionLabel = connect(
    (state: iState) => {
        return {
            version: state.startEndDate.version,
            startDate: state.startEndDate.start,
            endDate: state.startEndDate.end
        }
    }
)(_VersionLabel);


class _Waiting extends React.Component<{ waiting: boolean }, null> {

    render() {
        let staticRoot = (document.getElementById('static-root') as HTMLInputElement).value;
        let theClass = this.props.waiting ? 'load-is-waiting' : 'load-is-ready';

        return <img className={`${theClass} waiting-indicator`} src={`${staticRoot}/img/loadingIndicator/progress.gif`}
                    height={50} width={50}/>
    }
}

export const WaitingIndicator = connect(
    (state: iState) => {
        return {
            waiting: state.waiting,
        }
    }
)(_Waiting);

